export default __webpack_public_path__ + "static/new_02-2e78e6287927bc8302ab16a95976edca.webp";